import React, { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { ClientTypeE } from "../../models/enums";
import { RoutesE } from "../../routes/routesData";
import { useAppSelector } from "../../store/hooks";
import { selectCurrentUser } from "../../store/selectors/authSelectors";
import { isMobileOrTablet } from "../../utils/helpers/mediaQueries";
import BackButton from "../BackButton/BackButton";
import Icon from "../Icon/Icon";
import { Span } from "../Text/Text";
import getCampaignNameWithoutDate from "../../utils/helpers/getCampaignNameWithoutDate";

import styles from "./styles.module.scss";

type BreadcrumbsPropTypes = {
  campaignNumber: number;
  campaignName: string;
  deliveryNumber: number;
  deliveryName: string;
  withoutData?: boolean;
};

const Breadcrumbs: FC<BreadcrumbsPropTypes> = (props) => {
  const {
    campaignNumber,
    deliveryNumber,
    campaignName,
    deliveryName,
    withoutData,
  } = props;
  const user = useAppSelector(selectCurrentUser);
  const { pathname } = useLocation();

  // show back button for mobile
  // if (isMobileOrTablet()) {
  //     return <BackButton withText={false} />
  // }

  return withoutData ? (
    <>
      <div className={styles.wrapper}>
        <Link to={RoutesE.CAMPAIGNS}>
          <span className={styles.iconWrapper}>
            <Icon name="home" />
          </span>
        </Link>
        {user.clientType !== ClientTypeE["Delivery service"] &&
          !isMobileOrTablet() && (
            <>
              <Link to={RoutesE.CAMPAIGNS}>
                <Span>Campaigns</Span>
              </Link>
              <span>/</span>
            </>
          )}
      </div>
    </>
  ) : campaignName && user ? (
    <div className={styles.wrapper}>
      <Link to={RoutesE.CAMPAIGNS}>
        <span className={styles.iconWrapper}>
          <Icon name="home" />
        </span>
      </Link>
      {user.clientType !== ClientTypeE["Delivery service"] && (
        <>
          <Link to={RoutesE.CAMPAIGNS}>
            <Span>Campaigns</Span>
          </Link>
          <span>/</span>
        </>
      )}
      <span className={styles.campaignNumber}>{campaignNumber}</span>
      <Link to={`${RoutesE.CAMPAIGNS}/${campaignNumber}`}>
        <span className={styles.campaignName}>
          {isMobileOrTablet()
            ? getCampaignNameWithoutDate(campaignName)
            : campaignName}
        </span>
      </Link>
      {!isMobileOrTablet() && (
        <>
          <span>/</span>
          <span>{deliveryNumber}</span>
          <span className={styles.deliveryName}>{deliveryName}</span>
        </>
      )}
    </div>
  ) : (
    <></>
  );
};

export default Breadcrumbs;
